// extracted by mini-css-extract-plugin
export var cardHeader = "_hn-1";
export var contentCard = "_hn-0";
export var headerActions = "_hn-3";
export var reorderHandle = "_hn-5";
export var titleArea = "_hn-2";
export var titleAreaWithHandle = "_hn-4";